export const UIKIT_VERSION = "2.1.0";
export const SDK_VERSION = "1.4.0";
export const DEMO_VERSION = "2.1.0";

// These parameters need to be configured
export const appKey = "41117440#383391";
export const APP_ID = "15cb0d28b87b425ea613fc46f7c9f974";
export const appServer = "https://a41.chat.agora.io";

export const PRESENCE_CONFIG = [
  "Online",
  "Offline",
  "Away",
  "Busy",
  "Do Not Disturb",
  "Custom",
];
